export default "__VITE_ASSET__5d5c7077__"